var React = require('react');

function IconLinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.938,16.5c0,9.079-7.359,16.438-16.438,16.438S0.062,25.578,0.062,16.5c0-9.078,7.359-16.438,16.438-16.438\r\n\tS32.938,7.421,32.938,16.5z M7.855,8.407c0,1.196,0.966,2.167,2.164,2.167c1.193,0,2.162-0.971,2.162-2.167S11.213,6.24,10.02,6.24\r\n\tC8.821,6.24,7.855,7.211,7.855,8.407z M14.225,24.24h3.727v-5.945c0-1.57,0.296-3.09,2.236-3.09c1.914,0,1.938,1.795,1.938,3.189\r\n\tv5.846h3.729v-6.594c0-3.238-0.697-5.728-4.475-5.728c-1.814,0-3.031,0.997-3.529,1.942h-0.051v-1.645h-3.576V24.24z M8.109,24.248\r\n\th3.734V12.226H8.109V24.248z"}));
}

IconLinkedinInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"33px","height":"33px","viewBox":"0 0 33 33","enableBackground":"new 0 0 33 33","xmlSpace":"preserve"};

module.exports = IconLinkedinInline;

IconLinkedinInline.default = IconLinkedinInline;
